import { selectCatalogingOnSiteEnabled } from '../../../../catalog/selectors/CatalogSelectors';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { IContentAndLuidInfo } from '../../../../ts/mappers/DatabaseAndTableMapper';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { ISetTagsAction } from '../../../../ts/ServerApi/types/actionNames';
import { setExternalContentTagsAction, setTags } from '../../../actions/spaces/SetTagsActions';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { anyItemIsEmbeddedDatasource } from './IEntityActionHelpers';

export const SetTagsAction: IEntityAction<IContentInfo, ISetTagsAction> = {
  name: EntityActionNames.SetTags,
  translateName: Messages.tag_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: ISetTagsAction) => !!(availableActions && availableActions.setTags),
  createReduxAction: (targetItems: IContentInfo[]) => setTags(...targetItems)
};

export const SetExternalContentTagsAction: IEntityAction<IContentAndLuidInfo, ISetTagsAction> = {
  name: EntityActionNames.SetTags,
  translateName: Messages.tag_action,
  isVisible: (_, state) => selectCatalogingOnSiteEnabled(state) && FeatureFlags.catalogTagsEnabled,
  isClickable: (availableActions: ISetTagsAction) => !!(availableActions && availableActions.setTags),
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error('setTags was called without exactly one item');
    }

    const item = items[0];

    if (item.contentType === 'database' || item.contentType === 'table') {
      return setExternalContentTagsAction(item);
    } else {
      throw new Error(`Attempted to set external content tags on an unsupported content type '${item.contentType}'`);
    }
  }
};
